import SVG from "../../../Components/SVG";
import Overview from "../../../Components/Cards/Information/Overview";
import { displayNumber, hasDisplayValue } from "../../../helper/displayValue";

const money = (value) => {
  if (!hasDisplayValue(value)) return "-";
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return "-";
  return numeric < 0 ? `-$${displayNumber(Math.abs(numeric), { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : `$${displayNumber(numeric, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export default function MainStats({ accountData }) {
  return (
    <div className="flex flex-col p-3 gap-3 items-center rounded-2xl overflow-hidden bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <h3 className="flex gap-2.5 items-center mb-1.5 w-full justify-start sm:justify-center">
        <SVG
          name="stats"
          classname="stroke-zi-text-light dark:stroke-zi-text-dark size-5"
        />
        <span className="text-base font-medium text-zi-text-light/50 dark:text-zi-text-dark/50">
          آمار کلی
        </span>
      </h3>
      <div className="flex sm:flex-col gap-3 overflow-x-auto w-full">
        <Overview
          color="blue"
          width="250px"
          className=""
          title="بالانس"
          value={money(accountData?.current_balance)}
          data=""
          svgName="balance"
          svgClassName=""
        />
        <Overview
          color=""
          width="250px"
          className=""
          title="سود / زیان قطعی"
          pnl={true}
          value={money(accountData?.realized_pl)}
          data=""
          svgName={
            accountData !== null && accountData !== undefined
              ? Number(accountData.realized_pl) >= 0
                ? "pnl"
                : "pnlloss"
              : "pnl"
          }
          svgClassName=""
        />
        <Overview
          color=""
          width="250px"
          className=""
          title="سود / زیان غیر قطعی"
          pnl={true}
          value={money(accountData?.unrealized_pl)}
          data=""
          svgName={
            accountData !== null && accountData !== undefined
              ? accountData.unrealized_pl >= 0
                ? "pnl"
                : "pnlloss"
              : "pnl"
          }
          svgClassName=""
        />
        <Overview
          color="yellow"
          width="250px"
          className=""
          title="روزهای معاملاتی"
          days={true}
          value={hasDisplayValue(accountData?.trading_days) ? String(accountData.trading_days) : "-"}
          data=""
          svgName="days"
          svgClassName=""
        />
      </div>
    </div>
  );
}
